import React, { Component } from "react";
import PropTypes from "prop-types";
import avatar from "./avatar.svg";
import pattern from "./placeholder-image.jpg";
import "./Avatar.scss";

import cx from "classnames";

class Avatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleZoomImage: 0,
    };
  }

  static defaultProps = {
    size: "md",
    className: "",
    isProduct: false,
    withBorder: false,
  };

  static propTypes = {
    size: PropTypes.oneOf(["lg", "sm", "xs", "md"]),
    className: PropTypes.string,
    image: PropTypes.string,
    isProduct: PropTypes.bool,
    withBorder: PropTypes.bool,
  };

  toggleModal = imageSrc => {
    //Create the element using the createElement method.
    var myDiv = document.createElement("div");
    var myImage = document.createElement("img");
    var myOverlay = document.createElement("div");

    //Set its unique ID.
    myDiv.id = "zoom-image";

    //Set src to image.
    myImage.src = imageSrc;
    myImage.onmouseleave = () => {
      myDiv.classList.remove("--opened");
      setTimeout(() => {
        myDiv.remove();
        this.setState({ visibleZoomImage: 0 });
      }, 300);
    };

    //Set class.
    myOverlay.classList = "zoom-image__overlay";
    myOverlay.onclick = () => {
      myDiv.classList.remove("--opened");
      setTimeout(() => {
        myDiv.remove();
        this.setState({ visibleZoomImage: 0 });
      }, 300);
    };

    //Add your content to the DIV
    myDiv.appendChild(myImage);
    myDiv.appendChild(myOverlay);

    //Finally, append the element to the HTML body
    document.body.appendChild(myDiv);
    setTimeout(() => {
      myDiv.classList.add("--opened");
    }, 100);
  };

  onMouseEnterHandler = imageSrc => {
    this.setState({ visibleZoomImage: 1 });
    setTimeout(() => {
      if (this.state.visibleZoomImage === 1) {
        this.setState({ visibleZoomImage: 2 });
        this.toggleModal(imageSrc);
      }
    }, 500);
  };

  onMouseLeaveHandler = () => {
    if (this.state.visibleZoomImage === 1) {
      this.setState({ visibleZoomImage: 0 });
    }
  };

  render() {
    const { className, size, image, bigImage, isRectangle, isProduct, withBorder } = this.props;

    const classNames = cx("avatar", isRectangle && "avatar--rectangle", withBorder && "avatar--bordered", size && `avatar--${size}`, className);
    return (
      <div className={classNames}>
        {isProduct ? (
          <img
            src={image ? image : pattern}
            alt=""
            className={"avatar__image"}
            onClick={e => this.toggleModal(bigImage ? bigImage : pattern)}
            onMouseLeave={() => this.onMouseLeaveHandler()}
            onMouseEnter={e => this.onMouseEnterHandler(bigImage ? bigImage : pattern)}
          />
        ) : (
          <img
            src={image ? image : avatar}
            alt=""
            className={"avatar__image"}
            onClick={e => this.toggleModal(bigImage ? bigImage : pattern)}
            onMouseLeave={() => this.onMouseLeaveHandler()}
            onMouseEnter={e => this.onMouseEnterHandler(bigImage ? bigImage : avatar)}
          />
        )}
      </div>
    );
  }
}

export default Avatar;
